/**
 * Os oito papéis (ADR-041; o gravador, ADR-113), com o nome que o cliente lê e o que cada um
 * permite.
 *
 * <p>Está aqui, e não no dicionário do servidor, porque o texto de <b>o que o papel
 * permite</b> é explicação de tela, não vocabulário de protocolo. A matriz precisa estar
 * visível na hora de conceder — quem atribui papel sem saber o que ele abre acaba dando
 * administrador para todo mundo.
 *
 * <p>A lista de nomes, porém, é a mesma do servidor: um papel novo lá e ausente aqui
 * aparece cru na tela, e {@link papeisConhecidos} existe para que isso seja um teste, e não
 * uma descoberta em produção.
 */

export interface Papel {
  codigo: string;
  nome: string;
  permite: string;
  perigoso?: boolean;
}

export const PAPEIS: Papel[] = [
  {
    codigo: 'COMPANY_ADMIN',
    nome: 'Administração',
    permite: 'Tudo do console, inclusive conceder papéis. Não gera seriais.',
  },
  {
    codigo: 'COMPANY_CATALOG',
    nome: 'Catálogo',
    permite: 'Marcas, produtos e lotes. Não gera seriais nem marca itens.',
  },
  {
    codigo: 'COMPANY_PROVISIONER',
    nome: 'Provisionamento',
    permite: 'Gera seriais e vincula etiquetas. Administrador NÃO basta para isto.',
    perigoso: true,
  },
  {
    codigo: 'COMPANY_SECURITY',
    nome: 'Segurança',
    permite: 'Marca e desmarca itens, inclusive em massa. Vê a fila de alertas.',
    perigoso: true,
  },
  {
    codigo: 'COMPANY_ANALYST',
    nome: 'Análise',
    permite: 'Leitura de indicadores e de ancoragem. Não altera nada.',
  },
  {
    codigo: 'ACTOR_OPERATOR',
    nome: 'Operação em campo',
    permite: 'Abre sessão e registra leitura no aplicativo. Não entra no console.',
  },
  {
    codigo: 'ACTOR_SUPERVISOR',
    nome: 'Supervisão de campo',
    permite: 'Tudo do operador, mais o fechamento de sessão de outros.',
  },
  {
    codigo: 'ACTOR_RECORDER',
    nome: 'Gravação de etiquetas',
    permite:
      'Grava etiqueta NFC, pelo aplicativo, nos lotes liberados para a unidade. Não lê em sessão.',
    perigoso: true,
  },
];

const POR_CODIGO = new Map(PAPEIS.map((p) => [p.codigo, p]));

export function papeisConhecidos(): string[] {
  return PAPEIS.map((p) => p.codigo);
}

export function nomeDoPapel(codigo: string): string {
  return POR_CODIGO.get(codigo)?.nome ?? codigo;
}

/** Os papéis do console — os que fazem sentido oferecer numa tela de console. */
export const PAPEIS_DE_CONSOLE = PAPEIS.filter((p) => p.codigo.startsWith('COMPANY_'));
export const PAPEIS_DE_CAMPO = PAPEIS.filter((p) => p.codigo.startsWith('ACTOR_'));
